export default {
    title: 'Editar Perfil',
    save: 'Salvar',
    yes: 'Sim',
    no: 'Não',

    list: {
        title: 'Editar Perfil',
        personal: 'Dados pessoais',
        birth: 'Dados de nascimento',
        privacy: 'Privacidade',
        notifications: 'Notificações',
        account: 'Conta',
        terms: 'Termos e ajuda',
        language: 'Idioma'
    },

    personal: {
        title: 'Dados pessoais',
        changePicture: 'Alterar foto',
        name: 'Nome',
        gender: 'Gênero',
        genderFemale: 'Feminino',
        genderMale: 'Masculino',
        genderNonBinary: 'Não binário',
        referencedAs: 'Como gostaria de ser referenciado(a)?',
        referencedAsHe: 'Ele',
        referencedAsShe: 'Ela',
        profession: 'Profissão',
        about: 'Sobre você',
        socialNetworks: 'Redes Sociais',
        facebook: 'Facebook',
        facebookProfile: 'Seu perfil no Facebook',
        twitter: 'Twitter',
        twitterProfile: 'Seu perfil no Twitter',
        instagram: 'Instagram',
        instagramProfile: 'Seu perfil no Instagram',
        nameValidationLetters: 'Utilize apenas letras no Nome.',
        nameValidationMin: 'Mínimo de 3 caracteres no Nome.',
        saveSuccess: 'Dados atualizados com sucesso!',
        saveError: 'Não foi possível salvar. Tente novamente.'
    },

    birth: {
        title: 'Dados de nascimento',
        sectionTitle: 'Dados de nascimento',
        changeDataMessage:
            'Atenção: você pode alterar a data de nascimento apenas uma vez. Caso queira fazer o mapa de outra pessoa, crie um Mapa Extra.',
        changedDateMessage:
            'Atenção: você já alterou a data ou o local do seu nascimento. Para uma nova alteração, <link>fale com a gente</link>.',
        birthTimeNotInformed: 'Você ainda não informou o seu horário de nascimento.',
        city: 'Cidade',
        cityPlaceholder: 'Digite o nome da cidade',
        cityNotFound: 'Ops! Não encontramos sua cidade. Confira se digitou corretamente e tente de novo!',
        cityNotFoundLink: 'Não encontrou sua cidade? Buscar mais',
        dateOfBirth: 'Data de nascimento',
        day: 'Dia',
        month: 'Mês',
        year: 'Ano',
        birthTime: 'Horário de nascimento',
        hour: 'Hora',
        minute: 'Minuto',
        exactTimeMessage: 'Atenção! Informe a hora exata que consta na sua certidão de nascimento.',
        dateInvalid: 'Insira uma data válida até {date}.',
        updateData: 'Atualizar dados',
        createExtraChart: 'Criar um Mapa Extra',
        confirmTitle: 'Atenção',
        confirmMessage: 'Você pode alterar as informações apenas uma vez. Deseja prosseguir?',
        saveSuccess: 'Dados atualizados com sucesso!',
        saveError: 'Não foi possível salvar. Tente novamente.',
        alreadyEditedError: 'Você já alterou seus dados de nascimento uma vez.'
    },

    privacy: {
        title: 'Privacidade',
        sectionTitle: 'Informações pessoais',
        showAge: 'Exibir idade',
        showFacebook: 'Exibir Facebook no perfil',
        chartVisibility: 'Resumo do mapa astral',
        chartDescriptionVisibility: 'Descrição do mapa astral',
        visibleToAll: 'Visível para todos',
        visibleToMe: 'Apenas para mim',
        allowCompatibility: 'Permitir compatibilidade',
        allowCompatibilityHelp:
            'Deixe esta opção ativa caso você deseje que outras pessoas possam efetuar uma Compatibilidade Astral com você através de um botão em seu perfil!',
        saveSuccess: 'Informações atualizadas!',
        saveError: 'Não foi possível salvar. Tente novamente.',
        blockedTitle: 'Usuários bloqueados',
        blockedEmpty: 'Não há usuários bloqueados.',
        unblock: 'Desbloquear',
        unblockConfirmTitle: 'Desbloquear {name}?',
        unblockError: 'Não foi possível desbloquear. Tente novamente.'
    },

    notifications: {
        title: 'Notificações',
        emailTitle: 'E-mail',
        pushTitle: 'Notificações push',
        social: 'Notificações sociais',
        socialDetail: '(solicitações de amizade, etc)',
        content: 'Conteúdo astrológico e novidades',
        contentDetail: '(fases da lua, promoções, previsões mensais, etc)',
        horoscope: 'Horóscopo personalizado',
        horoscopeDetail: '(novos trânsitos, céu do momento, dicas da semana, etc)',
        promotions: 'Promoções e descontos',
        promotionsDetail: '(novas promoções, descontos em planos, etc)',
        saveSuccess: 'Informações atualizadas!',
        saveError: 'Não foi possível salvar. Tente novamente.'
    },

    account: {
        title: 'Conta',
        passwordTitle: 'Alterar senha',
        automaticPasswordNotice:
            'Atenção! Você recebeu uma senha automática em sua última solicitação. Por segurança, é importante que você altere a sua senha.',
        currentPassword: 'Senha atual',
        newPassword: 'Nova senha',
        confirmPassword: 'Confirme a senha',
        updatePassword: 'Atualizar senha',
        passwordCriteria: 'Use no mínimo 8 caracteres, com letras e números.',
        passwordTooShort: 'Mínimo de 8 caracteres.',
        passwordLowComplexity: 'A senha deve conter letras e números.',
        passwordMismatch: 'As senhas informadas não são iguais.',
        passwordSuccess: 'Sua senha foi alterada com sucesso!',
        passwordError: 'Sua senha não foi alterada devido a um problema de dados. Tente novamente.',
        emailTitle: 'Alterar e-mail',
        newEmail: 'Novo e-mail',
        confirmEmail: 'Confirme seu e-mail',
        updateEmail: 'Atualizar e-mail',
        emailSuggestion: 'Você quis dizer:',
        emailInvalid: 'Insira um e-mail válido.',
        emailMismatch: 'Os e-mails informados não são iguais.',
        emailSuccess:
            'Enviamos um e-mail de confirmação para {email}. Ao confirmar, seu e-mail será alterado e você será desconectado de todos os dispositivos.',
        emailError:
            'Tivemos um problema ao atualizar seu e-mail. Verifique seus dados ou tente novamente mais tarde.',
        emailErrorSocialLogin:
            'Sua conta usa login social, então o e-mail não pode ser alterado por aqui. Desvincule a conta para acessar com e-mail e senha.',
        emailErrorExists: 'Não foi possível concluir: o e-mail informado já existe em nossa base.',
        emailCountdown:
            'Você já alterou seu e-mail recentemente. Aguarde {days} dias para fazer uma nova solicitação.',
        emailCountdownSingle:
            'Você já alterou seu e-mail recentemente. Aguarde {days} dia para fazer uma nova solicitação.',
        unlinkTitle: 'Desvincular conta',
        unlinkDescription:
            'Crie uma senha para acessar o Astrolink por e-mail e senha. Ao desvincular, você não poderá mais usar o login social.',
        unlinkButton: 'Desvincular conta do {provider}',
        unlinkConfirmTitle: 'Desvincular conta do {provider}?',
        unlinkConfirm: 'Desvincular',
        unlinkError: 'Não foi possível desvincular a conta. Tente novamente mais tarde.',
        deleteTitle: 'Desativar conta'
    },

    terms: {
        title: 'Termos e ajuda',
        termsOfUse: 'Ver termos de uso',
        privacy: 'Ver a política de privacidade',
        contact: 'Precisa de ajuda? Fale conosco!',
        about: 'Quem somos?',
        help: 'Central de ajuda'
    },

    language: {
        title: 'Idioma',
        accountTitle: 'Idioma da Conta',
        warning: 'Atenção: Algumas das ferramentas e funcionalidades podem não estar disponíveis em todos os idiomas.',
        confirmTitle: 'Alterar idioma?',
        confirmMessage: 'Ao alterar o idioma você será desconectado e a página será recarregada. Deseja continuar?',
        confirmButton: 'Alterar Idioma',
        changeError: 'Não foi possível alterar o idioma. Tente novamente.',
        siteTitle: 'Idioma do site',
        siteButton: 'Alterar'
    }
};
